import { RoleAssignmentList } from '@/features/role-assignments';

const RoleAssignmentPage = () => {
  return <RoleAssignmentList />;
};

export default RoleAssignmentPage;
